import React from "react";
import { IDynamicBlockComponent } from "../../dynamicPageBuilder/IDynamicBlockComponent";
import Header from "../../components/Header/Header";

type HeaderBlockProps = {
  data: Array<{
    header_orange?: string;
    header?: string;
    sneakpeak?: string;
    content?: string;
    subheader?: string;
    className?: string;
    background?: string;
    reduce_top_margin: number;
    reduce_bottom_margin: number;
  }>;
};

const HeaderBlock: React.FunctionComponent<IDynamicBlockComponent> = ({
  blockData,
}): React.ReactElement => {
  const { data } = blockData as HeaderBlockProps;
  const [
    {
      header_orange = "",
      header = "",
      sneakpeak = "",
      content = "",
      subheader = "",
      background = "",
      reduce_top_margin,
      reduce_bottom_margin,
      className = "",
    },
  ] = data;
  return (
    <>
      <Header
        className={className}
        coloredTop={header_orange}
        header={header}
        boldText={sneakpeak}
        info={content}
        infoHtml
        info2={subheader}
        background={background}
        marginTop={reduce_top_margin}
        marginBottom={reduce_bottom_margin}
      />
    </>
  );
};

export default HeaderBlock;
